import Vue from 'vue';
import apiPath from '../service/apiPath.js';
import { requestApi } from '../service/requestApi.js';
import { Message } from 'element-ui';
import { setStore, getStore, removeStore } from '../utils/tools.js'

export default {
    login({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
            requestApi({
                url: apiPath.AUTH_USER_LOGIN,
                method: 'post',
                body: {
                    mobile: userInfo.mobile,
                    password: userInfo.password
                },
                successFn: (data) => {
                    resolve(data)
                },
                failFn: (data) => {
                    reject(data)
                },
            });
        })
    },
    logout({ commit }) {
        return new Promise((resolve, reject) => {
            requestApi({
                url: apiPath.AUTH_USER_LOGOUT,
                method: 'post',
                body: {
                },
                successFn: (data) => {
                    resolve(data)
                },
                failFn: (data) => {
                    reject(data)
                },
            });
        })
    },
    getCurUser({commit}){
        return requestApi({
            method: 'get',
            url: apiPath.AUTH_GET_CUR_USER,
            successFn: (data) => {
                commit('SET_USER_INFO', data);
            }
        });
    },
    getRoleList({commit}, query = {}){
        return requestApi({
            method: 'get',
            url: `${apiPath.AUTH_ROLE}`,
            options: {
                params: query
            },
            successFn: (data) => {
                commit('SET_ROLE_LIST', data);
            }
        });
    },
    getAuthPoint({commit, state}){
        if (state.authPoints.length) {
            return;
        }
        return requestApi({
            method: 'get',
            url: apiPath.GET_AUTH_TREE,
            body: {},
            successFn: (data) => {
                commit('SET_AUTH_POINT', data);
            }
        });
    },
    getEditorBase({commit, state}, query = {}){
        if (state.editorBases.length) {
            return false;
        }
        return requestApi({
            method: 'get',
            url: apiPath.HANDLER_EDITOR_BASE,
            options: {
                params: query
            },
            successFn: (data) => {
                commit('SET_EDITOR_BASE', data);
            }
        });
    },

    getDimChannels({commit, state}, query = {}){
        return requestApi({
            method: 'get',
            url: apiPath.GET_DIM_CHANNELS,
            options: {
                params: query
            },
            successFn: (data) => {
                commit('SET_DATA_CHANNELS', data);
            }
        });
    },

    getChannelGroups({commit, state}, query = {}){
        if (state.dataChannelGroups.list.length) {
            return false;
        }
        return requestApi({
            method: 'get',
            url: apiPath.CHANNEL_GROUPS,
            options: {
                params: query
            },
            successFn: (data) => {
                commit('SET_DATA_CHANNEL_GROUPS', data);
            }
        });
    },

    getFieldsSuite({commit, state}, query = {}){
        return requestApi({
            method: 'get',
            url: apiPath.HANDLER_FIELDS_SUITE,
            options: {
                params: query
            },
            successFn: (data) => {
                commit('SET_FIELDS_SUITE', data);
            }
        });
    },
}



// WEBPACK FOOTER //
// ./src/store/action.js